var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.addTeamFlag && !_vm.teamPermissionsFlag
        ? _c("div", [
            _c("div", { staticClass: "col-sm-12 col-xs-12" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-7 col-md-6 col-sm-6 col-xs-8" },
                  [
                    _c("search-box", {
                      on: { getList: _vm.filterTeamsList },
                      model: {
                        value: _vm.searchValue,
                        callback: function ($$v) {
                          _vm.searchValue = $$v
                        },
                        expression: "searchValue",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-5 col-md-6 col-sm-6 col-xs-4 text-right",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn emergo-blue-button",
                        on: { click: _vm.addTeamMemberSection },
                      },
                      [
                        _c("img", {
                          staticClass: "add_icon_img",
                          attrs: {
                            src: "/static/images/icons/plus_icon.svg",
                            alt: "plus-icon",
                          },
                        }),
                        _vm._v(" Add "),
                        _c("span", { staticClass: "hidden-xs" }, [
                          _vm._v("Team Member"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "col-md-12 col-sm-12 col-xs-12 mr-tp-10" },
              [
                _c("div", { staticClass: "toggle_switch" }, [
                  _c("span", [_vm._v("Two Factor Authentication")]),
                  _c("label", { staticClass: "switch" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.multi_factor_key,
                          expression: "multi_factor_key",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.multi_factor_key)
                          ? _vm._i(_vm.multi_factor_key, null) > -1
                          : _vm.multi_factor_key,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.multi_factor_key,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.multi_factor_key = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.multi_factor_key = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.multi_factor_key = $$c
                            }
                          },
                          function ($event) {
                            return _vm.updateMultiFactorAuthentication()
                          },
                        ],
                      },
                    }),
                    _c("span", { staticClass: "slider round" }),
                  ]),
                  _vm.multi_factor_key
                    ? _c("span", { staticClass: "switch_label" }, [
                        _vm._v("On"),
                      ])
                    : _c("span", { staticClass: "switch_label switch_off" }, [
                        _vm._v("Off"),
                      ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "col-md-12 col-sm-12 col-xs-12 mr-bt-10" },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-11 col-sm-11 col-xs-10" }, [
                    _vm._v(
                      " There are " +
                        _vm._s(_vm.teamMemberCount) +
                        " active team members. "
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-1 col-sm-1 col-xs-2 text-alg-right",
                    },
                    [
                      _c(
                        "el-popover",
                        {
                          key: _vm.roles.length,
                          attrs: {
                            placement: "bottom-end",
                            trigger: "click",
                            width: "350",
                          },
                          on: {
                            show: function ($event) {
                              _vm.infoActive = true
                            },
                            hide: function ($event) {
                              _vm.infoActive = false
                            },
                          },
                        },
                        [
                          !_vm.infoActive
                            ? _c("img", {
                                staticClass: "info-img",
                                attrs: {
                                  slot: "reference",
                                  src: "/static/images/icons/info_icon.svg",
                                  alt: "info-icon",
                                },
                                slot: "reference",
                              })
                            : _vm._e(),
                          _vm.infoActive
                            ? _c("img", {
                                staticClass: "info-img",
                                attrs: {
                                  slot: "reference",
                                  src: "/static/images/icons/info_icon_active.svg",
                                  alt: "infoactive-icon",
                                },
                                slot: "reference",
                              })
                            : _vm._e(),
                          _c("div", { staticClass: "info-tabs" }, [
                            _c(
                              "ul",
                              {
                                staticClass: "nav nav-tabs",
                                attrs: { role: "tablist" },
                              },
                              [
                                _c(
                                  "li",
                                  {
                                    staticClass: "nav-item",
                                    class: { active: _vm.activeTab == "role" },
                                    attrs: { role: "presentation" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "nav-link",
                                        attrs: {
                                          role: "tab",
                                          "data-toggle": "tab",
                                        },
                                      },
                                      [_vm._v("Role Definitions")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              _vm._l(_vm.roles, function (role, index) {
                                return _c("div", { key: index }, [
                                  _c("div", { staticClass: "info-header" }, [
                                    _vm._v(_vm._s(role.name)),
                                  ]),
                                  _c("div", { staticClass: "info-text" }, [
                                    _vm._v(_vm._s(role.description)),
                                  ]),
                                ])
                              }),
                              0
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "col-md-12 col-sm-12 col-xs-12 hidden-xs" },
              [
                _c("div", { staticClass: "row member-box-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-1 col-sm-1 col-xs-1 p-0 custom-checkbox sm-txt-alg-lt",
                    },
                    [
                      _c("span", { staticClass: "checkbox" }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectAll,
                                expression: "selectAll",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.selectAll)
                                ? _vm._i(_vm.selectAll, null) > -1
                                : _vm.selectAll,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectAll,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectAll = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectAll = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectAll = $$c
                                }
                              },
                            },
                          }),
                          _c("span", { staticClass: "cr" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._m(0),
                  _c(
                    "div",
                    { staticClass: "col-sm-6 p-0" },
                    [
                      !_vm.multi_factor_key
                        ? [
                            _c("div", { staticClass: "col-sm-6 info-header" }, [
                              _vm._v("Role"),
                            ]),
                            _c("div", { staticClass: "col-sm-6 info-header" }, [
                              _vm._v("Distributor"),
                            ]),
                          ]
                        : [
                            _c("div", { staticClass: "col-sm-4 info-header" }, [
                              _vm._v("Role"),
                            ]),
                            _c("div", { staticClass: "col-sm-4 info-header" }, [
                              _vm._v("Distributor"),
                            ]),
                            _c("div", { staticClass: "col-sm-4 info-header" }, [
                              _vm._v("IP Address"),
                            ]),
                          ],
                    ],
                    2
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "col-md-12 col-xs-12 container1" }, [
              _c("div", { staticClass: "section" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-12 col-sm-12 col-xs-12 scrollable-content",
                  },
                  _vm._l(_vm.filterMembers, function (member, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "row member-box-wrapper",
                        class: {
                          "opacity-7": _vm.loggedInUser.id === member.user_id,
                        },
                      },
                      [
                        _vm.loggedInUser.id !== member.user_id
                          ? [
                              _vm.validateRemoveAuthority(
                                member.assigned_role_id
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-1 col-sm-1 col-xs-2 p-0 sm-txt-alg-lt mt-4",
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "checkbox inline-checkbox",
                                          },
                                          [
                                            _c("label", [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.checkedValue,
                                                    expression: "checkedValue",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  value: member.user_id,
                                                  checked: Array.isArray(
                                                    _vm.checkedValue
                                                  )
                                                    ? _vm._i(
                                                        _vm.checkedValue,
                                                        member.user_id
                                                      ) > -1
                                                    : _vm.checkedValue,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a = _vm.checkedValue,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = member.user_id,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.checkedValue =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.checkedValue =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.checkedValue = $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _c("span", { staticClass: "cr" }),
                                            ]),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "fa fa-pencil",
                                          attrs: { "aria-hidden": "true" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openRbacPage(member)
                                            },
                                          },
                                        }),
                                      ]),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-1 col-sm-1 col-xs-2 p-0 sm-txt-alg-lt",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-pencil",
                                        attrs: { "aria-hidden": "true" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openRbacPage(member)
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                            ]
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "col-sm-5 col-xs-10 pl-0",
                            class: {
                              "col-sm-offset-1 col-xs-offset-2":
                                _vm.loggedInUser.id === member.user_id,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-12 col-xs-12 col-sm-12 xs-pd-rt-0 pl-0",
                              },
                              [
                                _c("div", { staticClass: "member_img" }, [
                                  member.profile_pic
                                    ? _c(
                                        "span",
                                        { staticClass: "relative-pos" },
                                        [
                                          _c("img", {
                                            staticClass: "profile-pic",
                                            attrs: {
                                              src: member.profile_pic,
                                              alt: "profile-icon",
                                            },
                                          }),
                                          member.is_restricted
                                            ? _c("img", {
                                                staticClass:
                                                  "notification-red-on-image",
                                                attrs: {
                                                  src: "/static/images/icons/blocked_icon.png",
                                                  alt: "blocked-icon",
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "profile-pic profile-pic-title custom-profile-pic-title relative-pos",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getInitials(
                                                member.first_name,
                                                member.last_name
                                              )
                                            ) + " "
                                          ),
                                          member.is_restricted
                                            ? _c("img", {
                                                staticClass: "notification-red",
                                                attrs: {
                                                  src: "/static/images/icons/blocked_icon.png",
                                                  alt: "blocked-icon",
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                ]),
                                _c("div", { staticClass: "member-text" }, [
                                  _c("div", { staticClass: "member-name" }, [
                                    _vm._v(
                                      _vm._s(
                                        member.first_name +
                                          " " +
                                          member.last_name
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "ft-wt member-name" },
                                    [_vm._v(_vm._s(member.email))]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "arrow-disp",
                                    on: {
                                      click: function ($event) {
                                        return _vm.dropDownEvent(member.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "xs-collapse-arrow",
                                      class: !_vm.xshide[member.id]
                                        ? "active"
                                        : "",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6" },
                          [
                            _c("team-member", {
                              attrs: {
                                roles: _vm.listAllRoles,
                                roleId: _vm.roleId,
                                member: member,
                                localDistributors: _vm.localDistributors,
                                selectedRolesList:
                                  _vm.selectedRolesList[member.id],
                                xshide: _vm.xshide[member.id],
                                multi_factor_key: _vm.multi_factor_key,
                              },
                              on: {
                                updateRole: _vm.updatedRole,
                                updateDistributor: _vm.emitedDistributor,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 footer remove_button_padding",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-4 col-sm-4 col-xs-12 xs-mr-bt-10 xs-pd-lt-0 xs-pd-rt-0",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-blue-button",
                        attrs: {
                          type: "button",
                          disabled: _vm.checkedValue.length === 0,
                        },
                        on: { click: _vm.openDeleteConfirmationPopup },
                      },
                      [_vm._v(" Remove Member(s) ")]
                    ),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm.addTeamFlag
        ? [
            _c("add-team-member", {
              attrs: {
                roles: _vm.roles,
                multi_factor_key: _vm.multi_factor_key,
                member: _vm.selectedMember,
                localDistributors: _vm.localDistributors,
                account_type_id: _vm.loggedInUser.account_type_id,
              },
              on: {
                cancelAddTeam: _vm.cancelAddTeam,
                getTeamMembers: _vm.getTeamMembers,
              },
            }),
          ]
        : _vm._e(),
      _vm.teamPermissionsFlag
        ? [
            _c("edit-team-member", {
              attrs: {
                roles: _vm.roles,
                multi_factor_key: _vm.multi_factor_key,
                member: _vm.selectedMember,
                distributors: _vm.localDistributors,
                account_type_id: _vm.loggedInUser.account_type_id,
              },
              on: {
                cancelAddTeam: _vm.cancelAddTeam,
                getTeamMembers: _vm.getTeamMembers,
              },
            }),
          ]
        : _vm._e(),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      _c("generic-popup", {
        attrs: {
          genericPopupId: _vm.genericPopupId,
          genericHeader: "Team Limit",
          genericBody: "upgradeTeams",
          max_number: _vm.max_team_members,
          isREP:
            _vm.loggedInUser.account_type_id === 2 ||
            _vm.loggedInUser.account_type_id === 4,
        },
        on: { emitUpgradeTeams: _vm.upgradeTeams },
      }),
      _c("upgrade-modal", {
        attrs: { addonType: "account" },
        on: { payForUpgradeService: _vm.payForUpgradeService },
      }),
      _c("delete-popup", {
        attrs: {
          deletewarnInfo: _vm.deleteWarningInfo,
          teamMembersList: _vm.teamMembersName,
        },
        on: {
          dashboardPublishDelete: function ($event) {
            return _vm.removeTeamMember()
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-5" }, [
      _c("span", { staticClass: "mr-lt-33 info-header member_label" }, [
        _vm._v("Member"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }